<template>
  <div class="role-manage">
    <page-header title="角色管理" icon="el-icon-s-check" />
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input v-model="searchForm.name" placeholder="请输入角色名称" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="权限字符">
          <el-input v-model="searchForm.roleKey" placeholder="请输入权限字符" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="角色状态" class="filter-item">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div class="card-title">
        <i class="el-icon-tickets"></i>
        <span>数据列表</span>
      </div>

      <!-- 操作按钮 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <!-- <el-button type="success" icon="el-icon-edit" @click="handleModify" :disabled="true">修改</el-button>
        <el-button type="danger" icon="el-icon-delete" @click="handleBatchDelete" :disabled="true">删除</el-button> -->
      </div>

      <!-- 角色列表 -->
      <el-table :data="tableData" style="width: 100%" border stripe @selection-change="handleSelectionChange" 
        element-loading-text="加载中..."
        
        v-loading="tableLoading"
      >
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <!-- <el-table-column prop="roleId" label="编号" width="80" align="center"></el-table-column> -->
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="roleKey" label="权限字符" align="center"></el-table-column>
        <el-table-column prop="remark" label="角色描述" align="center"></el-table-column>
        <!-- <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column> -->
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="'1'"
              :inactive-value="'0'"
              @change="handleStatusChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
            <!-- <el-button type="text" @click="handleDataScope(scope.row)">数据权限</el-button> -->
            <el-button 
              v-if="scope.row.name !== '管理员'" 
              type="text" 
              @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 修改角色对话框 -->
    <el-dialog title="修改角色" :visible.sync="editDialogVisible" width="500px" append-to-body>
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="80px">
        <el-form-item label="角色名称" prop="name" required>
          <el-input v-model="editForm.name" placeholder="请输入角色名称" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="权限字符" prop="roleKey" required>
          <el-input v-model="editForm.roleKey" placeholder="请输入权限字符" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="角色顺序" prop="sort" required>
          <el-input-number v-model="editForm.sort" :min="0" controls-position="right" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editForm.status">
            <el-radio label="1">正常</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-tree
            ref="menuTree"
            :data="menuTreeData"
            :props="defaultProps"
            show-checkbox
            check-strictly="true"
            node-key="id"
            v-model="editForm.menuIds"
            :default-checked-keys="editForm.menuIds">
          </el-tree>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" v-model="editForm.remark" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加数据权限对话框 -->
    <el-dialog title="分配数据权限" :visible.sync="dataScopeDialogVisible" width="500px" append-to-body>
      <el-form :model="dataScopeForm" ref="dataScopeForm" label-width="80px">
        <el-form-item label="角色名称">
          <el-input v-model="dataScopeForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="权限字符">
          <el-input v-model="dataScopeForm.roleKey" disabled></el-input>
        </el-form-item>
        <el-form-item label="权限范围">
          <el-select v-model="dataScopeForm.scope" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value=""></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dataScopeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataScope">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新增角色对话框 -->
    <el-dialog title="新增角色" :visible.sync="addDialogVisible" width="500px" append-to-body v-loading="tableLoading"
        element-loading-text="加载中...">
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="80px">
        <el-form-item label="角色名称" prop="name" required>
          <el-input v-model="editForm.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="权限字符" prop="roleKey" required>
          <el-input v-model="editForm.roleKey" placeholder="请输入权限字符"></el-input>
        </el-form-item>
        <el-form-item label="角色顺序" prop="sort" required>
          <el-input-number v-model="editForm.sort" :min="0" controls-position="right" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editForm.status">
            <el-radio label="1">正常</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-tree
            ref="menuTree"
            :data="menuTreeData"
            :props="defaultProps"
            show-checkbox
            check-strictly="true"
            node-key="id"
            v-model="editForm.menuIds">
          </el-tree>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" v-model="editForm.remark" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'RoleManage',
  components: {
    PageHeader
  },
  data() {
    return {
      tableLoading: false,
      disabled:false,
      searchForm: {
        name: '',
        roleKey: '',
        status: ''
      },
      tableData: [],
      multipleSelection: [],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      editDialogVisible: false,
      editForm: {
        roleId: '',
        name: '',
        roleKey: '',
        sort: 0,
        status: '1',
        remark: '',
        menuIds: []
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        roleKey: [
          { required: true, message: '请输入权限字符', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]+$/, message: '只能包含字母、数字和下划线', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序号', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: 'blur' }
        ]
      },
      dataScopeDialogVisible: false,
      dataScopeForm: {
        name: '',
        roleKey: '',
        scope: ''
      },
      addDialogVisible: false,
      menuTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      }
    }
  },
  methods: {
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取角色列表数据
    async fetchRoleList() {
      // 清空数据并显示加载状态
      this.tableData = []
      this.tableLoading = true
      this.total = 0

      try {
        const params = {
          name: this.searchForm.name,
          state: this.searchForm.status === '' ? -1 : parseInt(this.searchForm.status),
          page: this.currentPage,
          size: this.pageSize
        }
        
        const response = await request.post('/api/v1/role/list', params)
        
        if (response.data && Array.isArray(response.data.list)) {
          this.tableData = response.data.list.map(item => ({
            roleId: item.RoleID,
            name: item.RoleName,
            roleKey: item.RoleKey,
            sort: item.RoleSort,
            status: item.State.toString(),
            createTime: this.formatDate(item.CreatedAt),
            remark: item.Remark
          }))
          this.total = response.data.total || 0
        } else {
          console.error('返回数据格式不正确:', response.data)
          this.$message.error('数据格式不正确')
        }
      } catch (error) {
        console.error('获取角色列表出错:', error)
        if (error.response) {
          console.error('错误响应:', error.response)
        }
        this.$message.error('获取角色列表失败：' + (error.message || '未知错误'))
      } finally {
        // 无论成功失败都关闭加载状态
        this.tableLoading = false
      }
    },

    // 修改搜索方法
    handleSearch() {
      this.currentPage = 1 // 重置到第一页
      this.fetchRoleList()
    },

    // 修改重置方法
    handleReset() {
      this.searchForm = {
        name: '',
        roleKey: '',
        status: ''
      }
      this.currentPage = 1
      this.fetchRoleList()
    },

    // 修改分页方法
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchRoleList()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchRoleList()
    },

    handleAdd() {
      this.editForm = {
        roleId: '',
        name: '',
        roleKey: '',
        sort: 0,
        status: '1',
        remark: '',
        menuIds: []
      }

      
      this.addDialogVisible = true
    },
    handleModify() {
      if (this.multipleSelection.length !== 1) {
        this.$message.warning('请选择一条记录进行修改')
        return
      }
      this.handleEdit(this.multipleSelection[0])
    },
    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的记录')
        return
      }
      this.$confirm('确认删除选中的角色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 执行删除操作
        console.log('删除的角色：', this.multipleSelection)
      })
    },
    async handleEdit(row) {
      try {
        // 检查并打印row对象，以便调试
        console.log('编辑的角色数据:', row)
        
        // 获取角色权限信息
        const response = await request.post('/api/v1/role/permissions/list', {
          roleId: row.roleId || row.RoleID // 兼容两种可能的属性名
        })

        if (response.data && response.status === 1) {
          const roleData = response.data
          
          // 打印返回的数据，以便调试
          console.log('获取到的角色权限数据:', roleData)
          
          // 更新表单数据，添加默认值和类型转换
          this.editForm = {
            roleId: roleData.role?.RoleID || '',
            name: roleData.role?.RoleName || '',
            roleKey: roleData.role?.RoleKey || '',
            sort: roleData.role?.RoleSort || 0,
            status: (roleData.role?.State || 0).toString(),
            remark: roleData.role?.Remark || '',
            menuIds: Array.isArray(roleData.menuIds) ? roleData.menuIds : []
          }

          this.editDialogVisible = true

          // 等待DOM更新后设置树的选中状态
          this.$nextTick(() => {
            if (this.$refs.menuTree) {
              // 确保menuIds是数组
              const menuIds = Array.isArray(this.editForm.menuIds) ? this.editForm.menuIds : []
              this.$refs.menuTree.setCheckedKeys(menuIds)
            }
          })
        } else {
          throw new Error(response.data?.msg || '获取角色权限失败')
        }
      } catch (error) {
        console.error('获取角色权限出错:', error)
        this.$message.error('获取角色权限失败：' + (error.message || '未知错误'))
        // 关闭对话框
        this.editDialogVisible = false
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该角色?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await request.post('/api/v1/role/delete', {
          roleId: row.roleId
        })

        if (response.status === 1) {
          this.$message.success('删除成功')
          // 重新加载角色列表
          await this.fetchRoleList()
        } else {
          throw new Error(response.msg || '删除失败')
        }
      } catch (error) {
        // 如果用户点击取消，不显示错误提示
        if (error !== 'cancel') {
          console.error('删除角色出错:', error)
          this.$message.error(error.message || '删除失败')
        }
      }
    },
    handleDataScope(row) {
      this.dataScopeDialogVisible = true  // 打开弹窗
      // 填充表单数据
      this.dataScopeForm = {
        name: row.name,  // 角色名称，例如：系统管理员
        roleKey: row.roleKey,  // 权限字符，例如：admin
        scope: ''  // 权限范围，默认为空
      }
    },
    handleStatusChange(row) {
      // 实现状态切换逻辑
      console.log('状态切换：', row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    submitEditForm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.saveRole(this.editForm)
        } else {
          return false
        }
      })
    },
    submitDataScope() {
      // TODO: 调用设置数据权限接口
      console.log('设置数据权限：', this.dataScopeForm)
      this.$message.success('设置成功')
      this.dataScopeDialogVisible = false
    },
    async saveRole(formData) {
      try {
        // 显示加载状态
        this.tableLoading = true
        
        // 获取选中的菜单ID
        const checkedKeys = this.$refs.menuTree.getCheckedKeys();
        // 在check-strictly模式下，不需要使用半选状态的节点
        const menuIds = [...new Set(checkedKeys)];

        const params = {
          roleId: formData.roleId || '',
          roleName: formData.name.trim(),
          roleKey: formData.roleKey.trim(),
          roleSort: parseInt(formData.sort),
          state: parseInt(formData.status),
          remark: (formData.remark || '').trim(),
          menuIds: menuIds  // 只包含直接选中的节点ID
        }

        console.log('保存角色权限请求参数：', JSON.stringify(params, null, 2))
        
        const response = await request.post('/api/v1/role/save', params)
        
        if (response && response.status === 1) {
          this.$message.success(formData.roleId ? '修改成功' : '新增成功')
          this.editDialogVisible = false
          this.addDialogVisible = false
          // 保存成功后刷新页面数据
          await this.fetchRoleList()
          await this.getMenuTree()
        } else {
          throw new Error(response?.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存角色出错:', error)
        this.$message.error(error.message || '保存失败')
      } finally {
        // 无论成功失败都关闭加载状态
        this.tableLoading = false
      }
    },
    async getMenuTree() {
      try {
        const response = await request.post('/api/v1/menu/all')
        console.log('菜单接口原始响应：', response)

        if (!response.data) {
          throw new Error('接口返回数据为空')
        }

        // 确保返回的是数组
        const menuList = Array.isArray(response.data) ? response.data : []
        
        if (menuList.length === 0) {
          console.warn('获取到的菜单列表为空')
        }

        this.menuTreeData = this.convertToTree(menuList)
        console.log('转换后的菜单树数据：', this.menuTreeData)

      } catch (error) {
        console.error('获取菜单树出错：', error)
        this.$message.error('获取菜单树失败：' + (error.message || '未知错误'))
      }
    },
    // 将列表数据转换为树形结构的方法
    convertToTree(list) {
      if (!Array.isArray(list) || list.length === 0) {
        console.warn('convertToTree: 输入参数必须是非空数组')
        return []
      }

      // 创建一个以ID为键的映射对象
      const map = new Map()
      
      // 第一次遍历：创建所有节点的映射
      list.forEach(item => {
        map.set(item.MenuID, {
          id: item.MenuID,
          title: item.MenuName,
          parentId: item.ParentID,
          path: item.Path || '',
          component: item.Component || '',
          icon: item.Icon || '',
          sort: item.Sort || 0,
          type: item.Type || '',
          permission: item.Permission || '',
          visible: item.Visible,
          children: []
        })
      })

      // 构建树形结构
      const tree = []
      
      // 第二次遍历：构建父子关系
      list.forEach(item => {
        const node = map.get(item.MenuID)
        const parentId = item.ParentID

        if (parentId === '0' || parentId === 0) {
          // 顶级节点直接加入树中
          tree.push(node)
        } else {
          // 将当前节点添加到父节点的children中
          const parentNode = map.get(parentId)
          if (parentNode) {
            if (!parentNode.children) {
              parentNode.children = []
            }
            parentNode.children.push(node)
          } else {
            console.warn(`找不到父节点 ${parentId} 对应的节点，将 ${node.title} 作为顶级节点处理`)
            tree.push(node)
          }
        }
      })

      // 递归对每一层级按sort字段排序
      const sortTreeNodes = (nodes) => {
        if (!Array.isArray(nodes)) return
        
        nodes.sort((a, b) => {
          const sortA = Number(a.sort) || 0
          const sortB = Number(b.sort) || 0
          return sortA - sortB
        })

        nodes.forEach(node => {
          if (Array.isArray(node.children) && node.children.length > 0) {
            sortTreeNodes(node.children)
          }
        })
      }

      // 对树进行排序
      sortTreeNodes(tree)

      // 打印调试信息
      console.log('转换后的树形结构：', tree)
      
      return tree
    }
  },
  created() {
    this.fetchRoleList() // 组件创建时获取角色列表
    this.getMenuTree() // 获取菜单树数据
    console.log('菜单树数据：', this.menuTreeData)
  }
}
</script>

<style scoped>
.role-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);
}

.search-card,
.table-card {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  padding: 0;
}

.card-title {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.card-title i {
  margin-right: 8px;
  color: #409EFF;
}

.filter-item {
  width: 200px;
}

.filter-buttons {
  margin-left: 10px;
}

.operation-bar {
  margin: 20px;
}

.el-table {
  margin: 0;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table th) {
  padding: 12px 0;
  background-color: #f5f7fa;
}

.pagination-container {
  padding: 20px;
  text-align: right;
  background: #fff;
}

.el-button + .el-button {
  margin-left: 10px;
}
</style>
